export default __webpack_public_path__ + "static/media/Update4.ef617dfa.png";